// extracted by mini-css-extract-plugin
module.exports = {"CountersRow":"styles_CountersRow__1KBwx","CountersRow__Decreased":"styles_CountersRow__Decreased__3rGe_","CountersRow__Scrolled":"styles_CountersRow__Scrolled__Xjmx6"};